import "react";
import { keyframes as e, styled as t } from "styled-components";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/Primitives/Skeleton.tsx
var r = e`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: .5;
    }
`, i = t.div`
    animation: ${r} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    background-color: ${({ theme: e }) => e.colors.muted};
    border-radius: ${({ theme: e, $radius: t }) => t ? e.radii[t] || t : e.radii.md};
    width: ${({ $width: e }) => e ? typeof e == "number" ? `${e}px` : e : "100%"};
    height: ${({ $height: e }) => e ? typeof e == "number" ? `${e}px` : e : "20px"};
`, a = ({ width: e, height: t, radius: r, className: a, ...o }) => /* @__PURE__ */ n(i, {
	$width: e,
	$height: t,
	$radius: r,
	className: a,
	...o
});
//#endregion
export { a as Skeleton };
